import { render, staticRenderFns } from "./TopMenosVendidosCard.vue?vue&type=template&id=7ee0cda3"
import script from "./TopMenosVendidosCard.vue?vue&type=script&lang=js"
export * from "./TopMenosVendidosCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports